@if (tokens() && tokens().length > 0) {
    @if (!implicitSigning()) {
        <h2 data-bb="browser-selector-header">
            {{ 'browser.selector.title' | apContent }}
        </h2>
    }
    <div class="browser-selector-instruction">
        {{ 'browser.selector.instruction' | apContent }}
    </div>
    <ap-radio-group
        [control]="tokenControl"
        [messages]="errors"
        [description]="'browser.selector.instruction' | apContent"
        [descriptionHidden]="true"
    >
        @for (token of tokens(); track token) {
            <ap-radio-button [label]="encode(token.username)" name="tokens" [value]="token.keychainId" [formControl]="tokenControl">
            </ap-radio-button>
        }
    </ap-radio-group>
    <ap-button (onClick)="selectToken()"> {{ 'browser.selector.next' | apContent }}</ap-button>
} @else {
    <ap-browser-selector-skeleton></ap-browser-selector-skeleton>
}
